import { Box } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LiquidGlassCircleButton } from '../common/LiquidGlassCircleButton';

interface VoiceExpandMenuQuestProps {
  onNewQuest: () => void;
  onFromTemplate: () => void;
}

export const VoiceExpandMenuQuest: FC<VoiceExpandMenuQuestProps> = ({
  onNewQuest,
  onFromTemplate,
}) => {
  const { t } = useTranslation();
  return <>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '12px', width: '100%' }}>
      <Text weight="2" style={{ fontSize: 16, color: 'var(--tg-theme-text-color)' }}>
        {t('quest.fromTemplate')}
      </Text>
      <LiquidGlassCircleButton icon="content_copy" ariaLabel={t('quest.fromTemplate')} iconSize={22} onClick={onFromTemplate} />
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '12px', width: '100%' }}>
      <Text weight="2" style={{ fontSize: 16, color: 'var(--tg-theme-text-color)' }}>
        {t('quest.new')}
      </Text>
      <LiquidGlassCircleButton icon="explore" ariaLabel={t('quest.new')} onClick={onNewQuest} />
    </Box>
  </>;
};
